import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "modalBody", "form", "onboarding", "preferences", "submit"]
  static values = { patientId: Number }

  open(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    const modal = this.getModal()
    if (!modal) return

    this.resetToForm()
    this.showModal(modal)
  }

  close(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    this.hideModal(this.getModal())
  }

  submit(event) {
    event.preventDefault()

    const form = this.hasFormTarget ? this.formTarget : this.element.querySelector('[data-kiosk-session-modal-target="form"]')
    if (!form) return

    const onboardingEl = form.querySelector('input[type="checkbox"][name="includes_onboarding"]')
    const preferencesEl = form.querySelector('input[type="checkbox"][name="includes_preferences"]')

    if (onboardingEl && preferencesEl && !onboardingEl.checked && !preferencesEl.checked) {
      this.showFormError('Seleccioná al menos una opción (onboarding o preferencias).')
      return
    }

    const submitBtn = form.querySelector('[type="submit"]')
    const originalText = submitBtn?.innerHTML
    if (submitBtn) {
      submitBtn.disabled = true
      submitBtn.innerHTML = '<i class="fas fa-spinner fa-spin mr-2"></i>Generando...'
    }

    const formData = new FormData(form)
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')

    fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: {
        'X-CSRF-Token': csrfToken,
        'Accept': 'text/html'
      },
      credentials: 'same-origin'
    })
      .then(response => {
        if (!response.ok) {
          return response.text().then(text => { throw new Error(text || `HTTP ${response.status}`) })
        }
        return response.text()
      })
      .then(html => {
        const body = this.getModalBody()
        if (body) body.innerHTML = html
      })
      .catch(error => {
        this.showFormError(error.message || 'Error al generar el PIN')
        if (submitBtn) {
          submitBtn.disabled = false
          submitBtn.innerHTML = originalText
        }
      })
  }

  resetToForm() {
    const body = this.getModalBody()
    const template = this.element.querySelector('[data-kiosk-session-modal-target="form-template"]')
    if (body && template) {
      body.innerHTML = template.innerHTML
    }
  }

  showFormError(message) {
    const errorEl = this.findErrorEl()
    if (errorEl) {
      errorEl.textContent = message
      errorEl.classList.remove('d-none')
    }
  }

  clearError() {
    const errorEl = this.findErrorEl()
    if (errorEl) {
      errorEl.textContent = ''
      errorEl.classList.add('d-none')
    }
  }

  findErrorEl() {
    return this.element.querySelector('[data-kiosk-session-modal-target="error"]') ||
           this.getModalBody()?.querySelector('.kiosk-form-error')
  }

  getModal() {
    return this.hasModalTarget
      ? this.modalTarget
      : this.element.querySelector(`#kioskSessionModal-${this.patientIdValue}`)
  }

  getModalBody() {
    return this.hasModalBodyTarget
      ? this.modalBodyTarget
      : this.getModal()?.querySelector('[data-kiosk-session-modal-target="modalBody"]')
  }

  showModal(modal) {
    if (!modal) return

    if (typeof $ !== 'undefined' && $.fn.modal) {
      modal.removeAttribute('aria-hidden')
      $(modal).modal('show')
      return
    }

    modal.style.display = 'block'
    modal.classList.add('show')
    document.body.classList.add('modal-open')

    if (!document.getElementById(`kioskSessionModalBackdrop-${this.patientIdValue}`)) {
      const backdrop = document.createElement('div')
      backdrop.className = 'modal-backdrop fade show'
      backdrop.id = `kioskSessionModalBackdrop-${this.patientIdValue}`
      backdrop.addEventListener('click', () => this.hideModal(modal))
      document.body.appendChild(backdrop)
    }
    modal.removeAttribute('aria-hidden')
  }

  hideModal(modal) {
    if (!modal) return

    if (typeof $ !== 'undefined' && $.fn.modal) {
      $(modal).modal('hide')
      return
    }

    modal.setAttribute('aria-hidden', 'true')
    modal.style.display = 'none'
    modal.classList.remove('show')
    document.body.classList.remove('modal-open')

    const backdrop = document.getElementById(`kioskSessionModalBackdrop-${this.patientIdValue}`)
    if (backdrop) backdrop.remove()
  }
}
